import type { CreatePanelInput, PanelDetail } from '#shared/types';

/**
 * The form's starting values: the saved panel when editing, blanks when
 * creating.
 *
 * `user_id` is set from the session server-side; it is deliberately not a field.
 */
export function initialPanelValues(record?: PanelDetail): CreatePanelInput {
  if (!record) {
    return {
      name: '',
      code: '',
      owner_name: '',
      discount_percentage: 0,
      phone_number: '',
      email: '',
      contract: '',
    };
  }
  return {
    name: record.name,
    code: record.code,
    owner_name: record.owner_name,
    discount_percentage: record.discount_percentage,
    phone_number: record.phone_number,
    email: record.email,
    contract: record.contract ?? '',
  };
}
